<!-- iot 智能监测 -->
<style lang="stylus" scoped>
.iot {
  height: 277px;
  padding: 10px 20px;
  color: #fff;

  .title {
    margin-bottom: 20px;
    color: #77CAD8;
    font-size: 16px;
  }

  .main {
    width: 100%;
    height: 100%;
  }

  .device-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    .device-item {
      position: relative;
    }

    .device-detail {
      display: inline-block;
      margin-left: 38px;
    }

    .device-name {
      margin-bottom: 5px;
      font-size: 10px;
    }

    .device-num {
      font-size: 14px;
    }
  }

  .icon {
    position: absolute;
    left: 0;
    top: 3px;
    width: 32px;
    height: 32px;
    background: url('../../../../static/img/dashboard/iot-icon.png') no-repeat;
  }

  .icon-device1 {
    background-position: 0 0;
  }

  .icon-device2 {
    background-position: -115px 0;
  }

  .icon-device3 {
    background-position: -230px 0;
  }

  .icon-device4 {
    background-position: -340px 0;
  }

  .monitor {
    width: 414px;
    height: 180px;
    display: flex;

    .monitor1, .monitor2 {
      width: 204px;
      height: 180px;
      margin-right: 6px;
      overflow: hidden;
      position: relative;

      .swiper-wrap {
        width: 204px;
        height: 180px;

        .swiper-item {
          position: relative;
          width: 204px;
          height: 180px;

          .slide-img {
            width: 204px;
            height: 180px;
          }

          .msg {
            position: absolute;
            bottom: 0;
            width: 204px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: rgba(0, 0, 0, 0.5);
            color: #52FFFF;
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }

    .swiper-button-next0, .swiper-button-prev0, .swiper-button-next1, .swiper-button-prev1 {
      width: 20px;
      height: 23px;
      top: 152px;
      position: absolute;
      z-index: 1;
    }

    .swiper-button-prev0, .swiper-button-prev1 {
      background: url('../../../../static/img/base/left.png');
      background-size: 100% 100%;
      left: 4px;
    }

    .swiper-button-next0, .swiper-button-next1 {
      background: url('../../../../static/img/base/right.png');
      background-size: 100% 100%;
      left: 182px;
    }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="iot">
      <div class="title">物联网智能硬件设备数量:</div>
      <div class="main">
        <div class="device-wrap">
          <div class="device-item">
            <i class="icon icon-device1"></i>
            <div class="device-detail">
              <div class="device-name">监控设备</div>
              <div class="device-num">1825</div>
            </div>
          </div>
          <div class="device-item">
            <i class="icon icon-device2"></i>
            <div class="device-detail">
              <div class="device-name">气象站</div>
              <div class="device-num">990</div>
            </div>
          </div>
          <div class="device-item">
            <i class="icon icon-device3"></i>
            <div class="device-detail">
              <div class="device-name">传感器</div>
              <div class="device-num">1490</div>
            </div>
          </div>
          <div class="device-item">
            <i class="icon icon-device4"></i>
            <div class="device-detail">
              <div class="device-name">控制设备</div>
              <div class="device-num">765</div>
            </div>
          </div>
        </div>
        <div class="monitor">
          <div class="monitor1">
            <swiper :options="swiperOption" class="swiper-wrap" v-if="imgList1.length!=0">
              <swiper-slide v-for="(item,index) in imgList1" :key="index" class="list-item">
                <div class="swiper-item">
                  <img class="slide-img" :src="item.src" alt />
                  <!-- <div id="tablevideo" :style="contentStyle" class="slide-img"></div> -->
                  <div class="msg">{{item.name}}</div>
                </div>
              </swiper-slide>
            </swiper>
            <div v-show="imgList1.length>1" class="swiper-button-prev0"></div>
            <div v-show="imgList1.length>1" class="swiper-button-next0"></div>
          </div>

          <div class="monitor2">
            <swiper :options="swiperOption1" class="swiper-wrap" v-if="imgList2.length!=0">
              <swiper-slide v-for="(item,index) in imgList2" :key="index" class="list-item">
                <div class="swiper-item">
                  <img class="slide-img" :src="item.src" alt />
                  <div class="msg">{{item.name}}</div>
                </div>
              </swiper-slide>
            </swiper>
            <div v-show="imgList2.length>1" class="swiper-button-prev1"></div>
            <div v-show="imgList2.length>1" class="swiper-button-next1"></div>
          </div>
        </div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import pro1 from '../../../../static/img/dashboard/pro1.png';
import pro2 from '../../../../static/img/dashboard/pro2.png';
import pro3 from '../../../../static/img/dashboard/pro3.png';
import pro4 from '../../../../static/img/dashboard/pro4.png';
import pro5 from '../../../../static/img/dashboard/pro5.png';
import pro6 from '../../../../static/img/dashboard/pro6.png';
import pro7 from '../../../../static/img/dashboard/pro7.png';
// require('../../../video/swfobject');

window.devid = null;
window.self2 = null;
window.screenNum = '1';
window.setClickCallback2 = function (index) {
  for (let i = 0; i < parseInt(window.screenNum); i++) {
    document.getElementById('WebAPI3').setWindowSelected(false, i);
  }
  document.getElementById('WebAPI3').setWindowSelected(true, index);
  window.devid = document.getElementById('WebAPI3').getSelectedDevId();
  if (window.devid > 0) {
    // window.self2.sendCommand(1000);
  } else {
    // window.self2.$emit('setPTZ', false);
  }
};
window.self1 = null;

export default {
  data() {
    return {
      contentStyle: {
        height: '204px',
        width: '180px'
      },
      name: 'IOT智能监测',
      imgList1: [
        { name: '百色芒果园', src: pro6 }
        // { name: '圣女果', src: pro2 }
      ],
      imgList2: [
        { name: '牛心李', src: pro7 }
        // { name: '圣女果', src: pro4 }
      ],
      swiperOption: {
        slidesPerView: 1,
        notNextTick: true,
        loop: true,
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next0',
          prevEl: '.swiper-button-prev0'
        },
        speed: 800,
        direction: "horizontal"
      },
      swiperOption1: {
        slidesPerView: 1,
        notNextTick: true,
        loop: true,
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next1',
          prevEl: '.swiper-button-prev1'
        },
        speed: 800,
        direction: "horizontal"
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  mounted() {
    this.onload();
  },
  methods: {
    setCamera(deviceName) {  // 设置设备名称大于12个字符显示省略号
      return deviceName.length > 12 ? deviceName.substring(0, 11) + '...' : deviceName;
    },
    init() { // 初始化视频
      var deviceList = [{
        deviceName: '河凤桥乡赵棚村',
        deviceCode: '17967'
      }]
      for (var i = 0; i < 1; i++) {
        document.getElementById('WebAPI3').setClickCallback('setClickCallback2', i, i);
        document.getElementById('WebAPI3').playVideo('rtmp://dev.svideo.com.cn/myapp', deviceList[i].deviceCode, this.setCamera(deviceList[i].deviceName))
      }
    },
    rvalue() {
      var pageHost =
        document.location.protocol === 'https:' ? 'https://' : 'http://';
      var imgv =
        `<img src='${pageHost}www.adobe.com/images/shared/download_buttons/get_flash_player.gif' alt='Get Adobe Flash player' />`;
      return `<a href='http://www.adobe.com/go/getflashplayer'>${imgv}</a>`;
    },
    // 初始化flas
    onload() {
      window.self1 = this;
      var isFlashInstalled =
        (navigator.plugins && navigator.plugins['Shockwave Flash']) ||
        (window.ActiveXObject &&
          !!new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash'));
      var vhtml = document.getElementById('tablevideo');
      var ip = '';
      console.log(navigator)
      console.log(isFlashInstalled)
      if (isFlashInstalled) {
        vhtml.innerHTML =
          "<div id='flashContent'>" +
          '<p>' +
          'To view this page ensure that Adobe Flash Player version ' +
          '11.1.0 or greater is installed. ' +
          '</p>' +
          this.rvalue() +
          '</div>' +
          '<noscript>' +
          "<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000' width='100%' height='100%' id='WebAPI3'>" +
          "<param name='movie' value='" +
          ip +
          "/src/WebAPI5.swf' />" +
          "<param name='quality' value='high' />" +
          "<param name='bgcolor' value='#ffffff' />" +
          "<param name='allowScriptAccess' value='always' />" +
          "<param name='allowFullScreen' value='true' />" +
          "<param name='allowNetworking' value='all'>" +
          '<!--[if !IE]>-->' +
          "<object type='application/x-shockwave-flash' data='" +
          ip +
          "/src/WebAPI5.swf' width='100%' height='100%'>" +
          "<param name='quality' value='high' />" +
          "<param name='bgcolor' value='#ffffff' />" +
          "<param name='allowScriptAccess' value='always' />" +
          "<param name='allowFullScreen' value='true' />" +
          "<param name='allowNetworking' value='all'>" +
          '<!--<![endif]-->' +
          '<!--[if gte IE 6]>-->' +
          '<p> ' +
          'Either scripts and active content are not permitted to run or Adobe Flash Player version' +
          '11.1.0 or greater is not installed.' +
          '</p>' +
          '<!--<![endif]-->' +
          "<a href='http://www.adobe.com/go/getflashplayer'>" +
          "<img src='http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif' alt='Get Adobe Flash Player' />" +
          '</a>' +
          '<!--[if !IE]>-->' +
          '</object>' +
          '<!--<![endif]-->' +
          '</object>' +
          '</noscript>';
        // For version detection, set to min. required Flash Player version, or 0 (or 0.0.0), for no version detection.
        var swfVersionStr = '11.1.0';
        // To use express install, set to playerProductInstall.swf, otherwise the empty string.
        var xiSwfUrlStr = ip + '/playerProductInstall.swf';
        var flashvars = {};
        flashvars.initcompletecb = function () {
          setTimeout(() => {
            window.self1.init();
          }, 5);
        };
        flashvars.screenNum = 1;
        var params = {};
        params.quality = 'high';
        params.bgcolor = '#ffffff';
        params.allowscriptaccess = 'always';
        params.allowfullscreen = 'true';
        var attributes = {};
        attributes.id = 'WebAPI3';
        attributes.name = 'WebAPI3';
        attributes.align = 'middle';
        window.swfobject.embedSWF(
          ip + '/src/WebAPI5.swf',
          'flashContent',
          '100%',
          '100%',
          swfVersionStr,
          xiSwfUrlStr,
          flashvars,
          params,
          attributes
        );
        // JavaScript enabled so display the flashContent div in case it is not replaced with a swf object.
        window.swfobject.createCSS(
          '#flashContent',
          'display:block;text-align:left;'
        );
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?223d7e6c